import { z } from "zod";

// `username` no se registra en el formulario de edición (UserForm lo muestra
// de solo lectura, sin `register`): el valor por defecto (el username actual)
// sigue satisfaciendo `min(1)` sin que el campo sea editable — mismo patrón
// que `code` en catalogSchemas.ts para catálogos.
export const userFormSchema = z.object({
  name: z.string().trim().min(1, "El nombre completo es obligatorio"),
  username: z.string().trim().min(1, "El usuario es obligatorio"),
  email: z
    .string()
    .trim()
    .min(1, "El correo es obligatorio")
    .email("Correo inválido"),
  phone: z.string(),
  profileId: z.string().trim().min(1, "El perfil es obligatorio"),
  // Un lugar de validador es de un tipo u otro, nunca los dos (ANEXO-011): el
  // propio selector de tipo hace estructuralmente imposible marcar ambos.
  placeType: z.enum(["", "merchant", "workshop"]),
  placeId: z.string(),
});
export type UserFormValues = z.infer<typeof userFormSchema>;
